import React, { Fragment, useEffect, useState, useRef } from "react";
import { Link, useNavigate } from "react-router";
import {
  FilterIcon,
  ResetIcon,
  CaretUpSolidIcon,
  CaretDownSolidIcon,
} from "../../../assets/icons/index";
import SelectPageSize from "../../shared/common/pageSizeDropdown";
import Pagination from "../../shared/common/pagination";
import DropDownComponent from "../questions/metadataDropDownList";
import { IStandard } from "../../../model/interface/standard";
import DeleteModal from "../../shared/common/deleteModal";
import Loader from "../../shared/loader/loader";
import { getSubjectByState, getStateAll } from "../../../api/subject.service";
import { getStandards } from "../../../api/standard.service";
import { getAllDomainsBySubject } from "../../../api/domain.service";
import {
  deleteQuestion,
  getAllAuthoredQuestions,
} from "../../../api/question.service";
import { ITeacherQuestion } from "../../../model/interface/teacherQuestion";
import constant from "../../../utils/constant";
import TeacherQuestionTypeSelect from "../questions/teacherQuestionTypeSelect";
import PreviewModal from "../questions/previewModal";
import Tooltip from "../../shared/common/ellipsisText";
import AllowedTo from "../../shared/common/rbac";
import Permissions from "../../../utils/permissions";
import AccessDenied from "../../shared/common/accessDenied";
import { ISearchAuthoredQuestionRequest } from "../../../model/interface/searchAuthoredQuestionRequest";
import moment from "moment";
import { getTeachersByStateId } from "../../../api/user.service";

function TeacherQuestionList() {
  const [pageSize, setPageSize] = useState(10);
  const [pageNumber, setPageNumber] = useState(1);
  const [totalPages, setTotalPages] = useState<number>(0);
  const [showManagePopup, setShowManagePopup] = useState<boolean>(false);
  const [resetDropdownFlag, setResetDropdownFlag] = useState<boolean>(false);
  const [questionDelete, setQuestionDelete] = useState<number>(0);
  const [showDeletePopup, setShowDeletePopup] = useState<boolean>(false);
  const [questionList, setQuestionList] = useState<ITeacherQuestion[]>([]);
  const [sortAscending, setSortAscending] = useState<boolean>(true);
  const [orderByColumn, setOrderByColumn] = useState<string>("CreatedDate");
  const [sortDir, setSortDir] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);
  const [subjects, setSubjects] = useState([]);
  const [state, setState] = useState([]);
  const [domain, setDomain] = useState([]);
  const [standard, setStandard] = useState([]);
  const [questionTypeId, setQuestionTypeId] = useState<number>(0);
  const [stateId, setStateId] = useState(0);
  const [subjectId, setSubjectId] = useState<number>(0);
  const [domainId, setDomainId] = useState<number>(0);
  const [standardId, setStandardId] = useState<number>(0);
  const [questionId, setQuestionId] = useState<number>(0);
  const [teacherId, setTeacherId] = useState<number>(0);
  const navigate = useNavigate();
  const [enableDisableStates, setEnableDisableStates] = useState<boolean>(true);
  const [enableDisableSubjects, setEnableDisableSubjects] =
    useState<boolean>(true);
  const [enableDisableDomains, setEnableDisableDomains] =
    useState<boolean>(true);
  const [enableDisableStandards, setEnableDisableStandards] =
    useState<boolean>(true);
  const [isApproved, setisApproved] = useState<boolean>(true);
  const [isActiveSubject, setisActive] = useState<boolean>(true);
  const [filterQuestionId, setFilterQuestionId] = useState<number>();
  const [open, setOpen] = useState<boolean>(false);
  const [previewId, setPreviewId] = useState<string>("");
  const paginationRef: any = useRef(undefined);
  const pageSizeRef: any = useRef(undefined);
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [questionIdPreview, setQuestionIdPreview] = useState<number>();
  const [previewOwnerUserId, setPreviewOwnerUserId] = useState<number>();
  const childRef: any = useRef(undefined);
  const [isLoaded, setIsLoaded] = useState<boolean>(false);
  const [isFilter, setIsFilter] = useState<boolean>(false);
  const [dok, setDok] = useState<number>(0);
  const [teachers, setTeachers] = useState<Array<any>>([]);

  function handleSort(columnName) {
    setOrderByColumn(columnName);
    setSortAscending(!sortAscending);
    setSortDir(sortAscending ? "ASC" : "DESC");

    const searchQuestion: ISearchAuthoredQuestionRequest = {
      subjectId: subjectId,
      domainIds: domainId == 0 ? "" : domainId.toString(),
      standardIds: standardId == 0 ? "" : standardId.toString(),
      dok: dok,
      orderbyColumn: columnName,
      sortByDesc: sortAscending ? false : true,
      pageSize: pageSize,
      pageNumber: pageNumber,
      questionTypeIds: questionTypeId == 0 ? "" : questionTypeId.toString(),
      createdByUserId: teacherId,
    };

    bindQuestionListWithPageCheck(searchQuestion);
  }

  function resetFilterHandler() {
    setResetDropdownFlag(!resetDropdownFlag);
    setQuestionId(0);
    setQuestionTypeId(0);
    setStateId(0);
    setSubjectId(0);
    setDomainId(0);
    setStandardId(0);
    setDok(0);
    setTeacherId(0);
    setOrderByColumn("CreatedDate");
    setSortAscending(true);
    setEnableDisableStates(true);
    setEnableDisableSubjects(true);
    setEnableDisableDomains(true);
    setEnableDisableStandards(true);
    bindResetQuestionList();
    paginationRef?.current?.onReset();
    pageSizeRef?.current?.onReset();
    setTimeout(() => {
      setResetDropdownFlag(false);
    }, 1500);
    setFilterQuestionId(0);
  }

  function bindResetQuestionList() {
    const searchQuestion: ISearchAuthoredQuestionRequest = {
      subjectId: 0,
      domainIds: "",
      standardIds: "",
      dok: 0,
      orderbyColumn: orderByColumn,
      sortByDesc: true,
      pageSize: pageSize,
      pageNumber: pageNumber,
      questionTypeIds: "",
      createdByUserId: 0,
    };
    bindQuestionListWithPageCheck(searchQuestion);
  }

  function filterQuestionList() {
    bindQuestionList();
  }

  const bindQuestionListWithPageCheck = (
    filter: ISearchAuthoredQuestionRequest,
    onFilter?
  ) => {
    setLoading(true);
    getAllAuthoredQuestions(filter).then((response) => {
      setLoading(false);
      const pageCount = Math.ceil(response.data.totalRecords / pageSize);
      if (pageNumber > pageCount && pageNumber > 1) {
        setPageNumber(1);
      } else {
        setQuestionList(response.data.data);
        setTotalPages(pageCount);
        setTotalRecords(response.data.totalRecords);
      }

      if (onFilter) {
        paginationRef?.current?.onReset();
        pageSizeRef?.current?.onReset();
        setIsFilter(false);
      }
    });
  };

  function bindQuestionList(onFilter?) {
    if (onFilter) setIsFilter(true);

    const searchQuestion: ISearchAuthoredQuestionRequest = {
      subjectId: subjectId,
      domainIds: domainId == 0 ? "" : domainId.toString(),
      standardIds: standardId == 0 ? "" : standardId.toString(),
      dok: dok,
      orderbyColumn: orderByColumn,
      sortByDesc: sortAscending ? false : true,
      pageSize: pageSize,
      pageNumber: pageNumber,
      questionTypeIds: questionTypeId == 0 ? "" : questionTypeId.toString(),
      createdByUserId: teacherId,
    };
    bindQuestionListWithPageCheck(searchQuestion);
  }

  function handleDomainChange(selectedItem: any) {
    setDomainId(selectedItem);
  }

  function handleStandardChange(selectedItem: any) {
    setStandardId(selectedItem);
  }

  function handleQuestionTypeChange(selectedItem: any) {
    setQuestionTypeId(selectedItem.value);
    if (selectedItem.value > 0) setEnableDisableStates(false);
  }

  function handleStateChange(selectedItem: any) {
    setStateId(selectedItem);
  }

  function handleSubjectChange(selectedItem: any) {
    setSubjectId(selectedItem);
  }
  function handleDOKChange(selectedItem: any) {
    setDok(selectedItem);
  }
  function handleTeacherChange(selectedItem: any) {
    setTeacherId(selectedItem);
  }

  function handleShowPopup(show: boolean, rebindData?: boolean) {
    setShowManagePopup(show);
    if (rebindData) {
      bindQuestionList();
    }
  }

  function deleteRecord() {
    const userId = 1;
    deleteQuestion(questionDelete, userId).then(() => {
      setShowDeletePopup(false);
      setQuestionDelete(0);
      bindQuestionList();
    });
  }

  function closeDeletePopup() {
    setShowDeletePopup(false);
    setQuestionDelete(0);
  }

  const openModal = (id, questionId, ownerUserId) => {
    setOpen(true);
    setPreviewId(id);
    setQuestionIdPreview(questionId);
    setPreviewOwnerUserId(ownerUserId);
  };

  const popUpClose = (value) => {
    setOpen(value);
    setPreviewId("");
  };

  useEffect(() => {
    if (isLoaded && !isFilter) {
      bindQuestionList();
    }
  }, [pageNumber]);

  useEffect(() => {
    if (pageNumber === 1 && !isFilter) {
      bindQuestionList();
    } else {
      paginationRef?.current?.onReset();
    }
  }, [pageSize]);

  useEffect(() => {
    bindStateData();
    if (stateId) {
      subjectByStateId();
      teachersByStateId();
    }

    if (subjectId) {
      domainBySubjectId();
    }

    if (domainId) {
      standardByDomainId();
    }
  }, [questionTypeId, stateId, subjectId, domainId]);

  const subjectByStateId = () => {
    async function subjectReload() {
      setLoading(true);
      const response = getSubjectByState(
        pageSize,
        pageNumber,
        stateId,
        isActiveSubject,
        isApproved
      );
      const data = (await response).data;
      const options = data.data.map((item) => {
        return {
          label: item.name,
          value: item.subjectId,
        };
      });
      setSubjects(options);
      setLoading(false);
    }
    subjectReload();
  };

  const bindStateData = () => {
    async function stateReload() {
      setLoading(true);
      const response = getStateAll(100, pageNumber);
      const data = (await response).data;
      const options = data.data.map((item) => {
        return {
          label: item.name,
          value: item.stateId,
        };
      });
      setState(options);
      setLoading(false);
    }
    stateReload();
  };

  function standardByDomainId() {
    const standard: IStandard = {
      name: "",
      contentAreaId: "",
      subjectId: "",
      domainId: domainId + "",
      code: "",
      isActive: true,
      isApproved: true,
      description: "",
      loadOrder: 0,
      pageSize: pageSize,
      pageNumber: pageNumber,
      orderbyColumn: "Name",
      sortDir: "ASC",
    };
    getStandards(standard).then((response: any) => {
      const options = response.data.data.map((item) => {
        return {
          label: `(${item.code}) ${item.name}`,
          value: item.standardId,
        };
      });
      setStandard(options);
    });
  }

  const domainBySubjectId = () => {
    getAllDomainsBySubject(subjectId, pageSize, pageNumber).then((res) => {
      const options = res.data.data.map((item) => {
        return {
          label: item.name,
          value: item.domainId,
        };
      });
      setDomain(options);
    });
  };

  const teachersByStateId = () => {
    getTeachersByStateId(stateId).then((res) => {
      const options = res.data.map((item) => {
        return {
          label: item.firstName + " " + item.lastName,
          value: item.userId,
        };
      });
      setTeachers(options);
    });
  };

  const handleRedirect = () => {
    navigate(constant.AUTHORQUESTION, { state: { questionIdToEdit: null } });
  };

  /** Code to implement input type number to support all browsers */
  useEffect(() => {
    const input = document.getElementById("questionId");
    if (input) {
      input.addEventListener("keypress", (e: any) => {
        const keyValue = e.key;
        if (!e.target.value && e.key == 0) {
          e.preventDefault();
        } else {
          if (!/[0-9.]/.test(keyValue)) {
            e.preventDefault();
          }
        }
      });
    }
  }, []);

  function handleFilterQuestionIdChange(e: any) {
    setFilterQuestionId(e.target.value);
  }

  function redirectToDomainDetail(domainId) {
    navigate(constant.EDITDOMAIN.replace(":id", domainId.toString()));
  }
  function redirectToSubjectDetail(subjectId) {
    navigate(constant.SUBJECTDETAIL.replace(":id", subjectId.toString()));
  }
  function redirectToStandardDetail(standardId) {
    navigate(constant.EDITSTANDARD.replace(":id", standardId.toString()));
  }

  return (
    <AllowedTo
      perform={Permissions.teacher_questions_view}
      no={() => <AccessDenied />}
    >
      {loading && <Loader />}

      {showDeletePopup && (
        <DeleteModal
          closeDeleteModal={closeDeletePopup}
          deleteRecord={deleteRecord}
        />
      )}
      <PreviewModal
        modal={openModal}
        show={open}
        changeValue={popUpClose}
        itemRef={previewId}
        questionIdPreview={questionIdPreview}
        isTeacherQuestion={true}
        teacherQuestionOwnerUserId={previewOwnerUserId}
      ></PreviewModal>

      <div className="flex-1 overflow-auto">
        <div className=" h-auto min-h-half w-full rounded-bl-3xl bg-site-teal px-8  py-8 pt-0 pb-14 mt-7 ">
          <div className="relative  py-1">
            <div className="overlay-image-main pointer-events-none fixed left-0 top-0 w-screen h-screen z-20"></div>
            <div className="flex items-center justify-between pb-4">
              <h3 className="text-lg font-light text-gray-900">
                Teacher Questions
              </h3>
            </div>
            <div className={"pt-6"}>
              <div className={"grid grid-cols-12 gap-5 border-b pb-6"}>
                <div className="col-span-3">
                  <div className="text-sm text-gray-700">Question Type</div>
                  <div className="mt-1 text-sm">
                    <TeacherQuestionTypeSelect
                      onChange={handleQuestionTypeChange}
                      value={questionTypeId}
                    ></TeacherQuestionTypeSelect>
                  </div>
                </div>

                <div className={"col-span-3 ..."}>
                  <div className="text-sm text-gray-700"> State</div>
                  <div className="mt-1 text-sm">
                    <DropDownComponent
                      dropName={"stateList"}
                      dropValue={state}
                      resetDropdown={resetDropdownFlag}
                      defaultValue={""}
                      dropSelect={handleStateChange}
                      disabled={enableDisableStates}
                      enableDisableSubjects={setEnableDisableSubjects}
                    ></DropDownComponent>
                  </div>
                </div>

                <div className={"col-span-3"}>
                  <div className={"text-sm text-gray-700"}>Subject</div>
                  <div className="mt-1 text-sm">
                    <DropDownComponent
                      dropName={"subjectList"}
                      dropValue={subjects}
                      resetDropdown={resetDropdownFlag}
                      defaultValue={""}
                      dropSelect={handleSubjectChange}
                      disabled={enableDisableSubjects}
                      enableDisableDomains={setEnableDisableDomains}
                    ></DropDownComponent>
                  </div>
                </div>

                <div className={"col-span-3"}>
                  <div className="text-sm text-gray-700">Domain</div>
                  <div className="mt-1 text-sm">
                    <DropDownComponent
                      dropName={"domainList"}
                      dropValue={domain}
                      defaultValue={""}
                      resetDropdown={resetDropdownFlag}
                      dropSelect={handleDomainChange}
                      disabled={enableDisableDomains}
                      enableDisableStandards={setEnableDisableStandards}
                    ></DropDownComponent>
                  </div>
                </div>

                <div className={"col-span-3"}>
                  <div className="text-sm text-gray-700">Standard</div>
                  <div className="mt-1 text-sm">
                    <DropDownComponent
                      dropName={"standardList"}
                      dropValue={standard}
                      defaultValue={""}
                      resetDropdown={resetDropdownFlag}
                      dropSelect={handleStandardChange}
                      disabled={enableDisableStandards}
                      questionId={questionId}
                      setQuestionId={setQuestionId}
                    ></DropDownComponent>
                  </div>
                </div>

                <div className={"col-span-3"}>
                  <div className="text-sm text-gray-700">DOK</div>
                  <div className="mt-1 text-sm">
                    <DropDownComponent
                      dropName={"dokList"}
                      dropValue={constant.DOK}
                      resetDropdown={resetDropdownFlag}
                      defaultValue={""}
                      dropSelect={handleDOKChange}
                    ></DropDownComponent>
                  </div>
                </div>

                <div className={"col-span-3"}>
                  <div className="text-sm text-gray-700">Authored By</div>
                  <div className="mt-1 text-sm">
                    <DropDownComponent
                      dropName={"teachersList"}
                      dropValue={teachers}
                      resetDropdown={resetDropdownFlag}
                      defaultValue={""}
                      dropSelect={handleTeacherChange}
                      disabled={enableDisableSubjects}
                    ></DropDownComponent>
                  </div>
                </div>
              </div>

              <div className={"grid grid-cols-12 gap-5"}></div>
              <div className="flex mt-4 items-center justify-between">
                <div>
                  <button
                    type="submit"
                    className="mt-4 inline-flex items-center text-sm text-white dark:text-white gap-2 bg-primary-color hover:bg-secondary-color py-1.5 px-4 rounded-lg"
                    onClick={() => filterQuestionList()}
                  >
                    <FilterIcon className="w-3 h-3"></FilterIcon>
                    <span>Filter</span>
                  </button>
                  <button
                    type="button"
                    className="mt-4 py-1.5 px-4 inline-flex ml-3 items-center text-sm rounded-lg text-gray-700 text-primary-color border border-gray-300 gap-2 bg-white hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color "
                    onClick={() => resetFilterHandler()}
                  >
                    <ResetIcon className="w-3 h-3"></ResetIcon>
                    <span>Reset Filter</span>
                  </button>
                </div>
              </div>
            </div>
            <div id="dataContainer" className="mt-4">
              <div className="flex flex-col mt-1">
                <div className="-my-2 relative sm:-mx-6 lg:-mx-8">
                  <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                    <div className="shadow border-b border-gray-200">
                      <table className="min-w-full divide-y divide-gray-200">
                        <thead className="bg-primary-color">
                          <tr>
                            <th
                              scope="col"
                              className="px-3 py-2 pl-6 font-light text-sm text-left text-white dark:text-white tracking-wider w-32 rounded-tl-lg
                              "
                            >
                              <span className="flex gap-2">
                                Create Date
                                <span className="cursor-pointer">
                                  {!sortAscending &&
                                  orderByColumn === "CreatedDate" ? (
                                    <CaretUpSolidIcon
                                      onClick={() => handleSort("CreatedDate")}
                                      className="w-5 h-5"
                                    ></CaretUpSolidIcon>
                                  ) : (
                                    <CaretDownSolidIcon
                                      onClick={() => handleSort("CreatedDate")}
                                      className="w-5 h-5"
                                    ></CaretDownSolidIcon>
                                  )}
                                </span>
                              </span>
                            </th>
                            <th
                              scope="col"
                              className="px-3 py-2 font-light whitespace-wrap text-sm text-left text-white dark:text-white "
                            >
                              <span className="flex gap-2">
                                Question - Click to Preview
                              </span>
                            </th>

                            <th
                              scope="col"
                              className="px-3 py-2 pl-6 font-light text-sm text-left text-white dark:text-white tracking-wider"
                            >
                              <span className="flex gap-2">Subject</span>
                            </th>
                            <th
                              scope="col"
                              className="px-3 py-2 font-light whitespace-wrap text-sm text-left text-white dark:text-white "
                            >
                              <span className="flex gap-2">Classification</span>
                            </th>

                            <th
                              scope="col"
                              className="px-3 py-2 font-light whitespace-wrap text-sm text-left text-white dark:text-white"
                            >
                              <span className="flex gap-2">Question Type</span>
                            </th>

                            <th
                              scope="col"
                              className="px-3 py-2 font-light text-sm text-center text-white dark:text-white tracking-wider rounded-tr-lg
                              "
                            ></th>
                          </tr>
                        </thead>
                        <tbody>
                          {questionList.map((question, index) => (
                            <tr
                              key={question.teacherQuestionId}
                              className={
                                index % 2 === 0 ? "bg-white" : "bg-gray-100"
                              }
                            >
                              <td className="px-3 py-2  pl-6 whitespace-wrap text-sm text-left font-normal text-gray-500">
                                {question.createdDate &&
                                  moment(question.createdDate).format(
                                    "MM-DD-yyyy"
                                  )}
                              </td>
                              <td className="px-3 py-2  pl-6 whitespace-wrap text-sm text-left font-normal text-gray-500">
                                {question?.questionText && (
                                  <a
                                    onClick={() =>
                                      openModal(
                                        question.questionReferenceId,
                                        question.teacherQuestionId,
                                        question.createdByUserId
                                      )
                                    }
                                  >
                                    <Tooltip text={question?.questionText} />
                                  </a>
                                )}
                              </td>
                              <td className="px-3 py-2  pl-6 whitespace-wrap text-sm text-left font-normal text-gray-500">
                                <Link
                                  className="cursor-pointer font-medium text-indigo-600 hover:text-indigo-500 hover:underline"
                                  to={constant.SUBJECTDETAIL.replace(
                                    ":id",
                                    question.subjectId!.toString()
                                  )}
                                >
                                  {question.subjectName}{" "}
                                </Link>
                              </td>
                              <td className="px-3 py-2 whitespace-wrap text-sm text-left font-normal text-gray-500">
                                <div className="grid">
                                  {question.domainName}
                                </div>
                                <div className="grid">
                                  {question.standardName}
                                </div>
                              </td>
                              <td className="px-3 py-2 whitespace-wrap text-sm text-left font-normal text-gray-500">
                                {question.questionTypeName}
                              </td>
                              {/* <td className="flex justify-end items-center px-3 py-2 whitespace-wrap text-sm text-center font-normal text-gray-700">
                                <div className="flex justify-center items-center space-x-2">
                                  <Menu
                                    as="div"
                                    className="relative flex justify-end items-center"
                                  >
                                    <Menu.Button className="h-7 bg-white inline-flex items-center justify-center text-gray-400 rounded-full hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-bg-primary-color">
                                      <span className="sr-only">
                                        Open options
                                      </span>
                                      <DotsVerticalIcon
                                        className="w-5 h-5"
                                        aria-hidden="true"
                                      />
                                    </Menu.Button>
                                    <Transition
                                      as={Fragment}
                                      enter="transition ease-out duration-100"
                                      enterFrom="transform opacity-0 scale-95"
                                      enterTo="transform opacity-100 scale-100"
                                      leave="transition ease-in duration-75"
                                      leaveFrom="transform opacity-100 scale-100"
                                      leaveTo="transform opacity-0 scale-95"
                                    >
                                      <Menu.Items className="mx-3 origin-top-right absolute right-7 top-0 w-48 mt-1 rounded-md shadow-lg z-10 bg-white ring-1 ring-black ring-opacity-5 divide-y divide-gray-200 focus:outline-none">
                                        <div className="py-1">
                                          <Menu.Item>
                                            {({ active }) => (
                                              <a
                                                onClick={() =>
                                                  openModal(
                                                    question.questionReferenceId,
                                                    question.teacherQuestionId
                                                  )
                                                }
                                                className={classNames(
                                                  active
                                                    ? "bg-gray-100 text-gray-900"
                                                    : "text-gray-700",
                                                  "group flex items-center px-4 py-2 text-sm"
                                                )}
                                              >
                                                <PreviewIcon className="mr-3 h-5 w-5 text-xs font-light cursor-pointer text-gray-400 hover:text-secondary-color transaction ease-in-out duration-300" />
                                                Preview Question
                                              </a>
                                            )}
                                          </Menu.Item>
                                       <AllowedTo
                                            perform={
                                              Permissions.teacher_questions_modify
                                            }
                                          >
                                            <Menu.Item>
                                              {({ active }) => (
                                                <a
                                                  onClick={(e) =>
                                                    editHandler(
                                                      question.teacherQuestionId
                                                    )
                                                  }
                                                  className={classNames(
                                                    active
                                                      ? "bg-gray-100 text-gray-900"
                                                      : "text-gray-700",
                                                    "group flex items-center px-4 py-2 text-sm"
                                                  )}
                                                >
                                                  <EditIcon className="mr-3 h-5 w-5 text-xs font-light cursor-pointer hover:text-secondary-color transaction ease-in-out duration-300" />
                                                  Edit
                                                </a>
                                              )}
                                            </Menu.Item>
                                          </AllowedTo> 
                                        </div>
                                        <AllowedTo
                                          perform={
                                            Permissions.teacher_questions_delete
                                          }
                                        >
                                          <div className="py-1">
                                            <Menu.Item>
                                              {({ active }) => (
                                                <a
                                                  onClick={() =>
                                                    confirmDelete(
                                                      question.teacherQuestionId
                                                    )
                                                  }
                                                  className={classNames(
                                                    active
                                                      ? "bg-gray-100 text-gray-900"
                                                      : "text-gray-700",
                                                    "group flex items-center px-4 py-2 text-sm"
                                                  )}
                                                >
                                                  <DeleteIcon className="mr-3 h-5 w-5 text-xs font-light cursor-pointer hover:text-red-500 transaction ease-in-out duration-300" />
                                                  Delete
                                                </a>
                                              )}
                                            </Menu.Item>
                                          </div>
                                        </AllowedTo>
                                      </Menu.Items>
                                    </Transition>
                                  </Menu>
                                </div>
                              </td> */}
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div className="flex justify-between items-center">
                  {questionList.length !== 0 ? (
                    <>
                      <Pagination
                        pages={totalPages}
                        setPageNumber={setPageNumber}
                        ref={paginationRef}
                      />
                      <span>
                        <span className="text-sm pr-4 ml-auto text-left-700">
                          Showing {pageNumber} to{" "}
                          {totalRecords < pageSize ? totalRecords : pageSize} of{" "}
                          {totalRecords} results
                        </span>

                        <SelectPageSize
                          setPageSize={setPageSize}
                          type={"second"}
                          ref={pageSizeRef}
                        />
                      </span>
                    </>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </AllowedTo>
  );
}

export default TeacherQuestionList;
